import { HttpClient, HttpHeaders } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable, throwError, from } from "rxjs";
import { catchError, map, mergeMap } from "rxjs/operators";
import { OptionsType } from "../utils/handshake.model";
import { HandShakeService } from "../services/handshake.service";
import { createUrl } from "@servicestack/client";
import { HandShakeConfig } from "../utils/handshake.config";

@Injectable()
export class BaseService {
    constructor(
        private http: HttpClient,
        private handshakeService: HandShakeService
    ) { }

    public call<T>(
        url: string,
        callback: (endpoint: string) => Observable<T>,
        callAPI = true
    ) {
        return callback(createUrl(url, null));
    }

    public handShakeAndCall<T>(
        url: string,
        data: object,
        captchaSSID: string = null,
        callback: (
            endpoint: string,
            encryptData: object,
            opts: OptionsType
        ) => Observable<T> = null,
        isHandshake
    ) {
        if (isHandshake) {
            if (!callback) {
                callback = this.DEFAULT_POST_FUNC;
            }

            return from(this.handshakeService.handShakeAllIn(data)).pipe(
                catchError((error) => {
                    console.log(
                        "handshake failed " + error + url + JSON.stringify(data)
                    );
                    return throwError("HSKFAILED");
                }),
                mergeMap((secret) => {
                    // console.log(
                    //     "handshake success " + url + JSON.stringify(data)
                    // );
                    let options = new OptionsType();
                    options.headers = options.headers.append(
                        HandShakeConfig.pageIdHeader,
                        secret.ssId
                    );
                    if (captchaSSID) {
                        options.headers.append(
                            HandShakeConfig.captchaIdHeader,
                            captchaSSID
                        );
                    }
                    return callback(
                        createUrl(url, null),
                        { Data: secret.data },
                        options
                    );
                })
            );
        } else {
            let options = new OptionsType();

            return callback(createUrl(url, null), data, options);
        }
    }

    private readonly DEFAULT_POST_FUNC = (
        endpoint: string,
        encryptedData: object,
        opts: OptionsType
    ): Observable<any> => {
        return this.http
            .post(endpoint, encryptedData, opts)
            .pipe(map((response: Response) => response.json()));
    };
}